import { useRootTypeContext } from "@/pages/configurations/rootTypes/context/RootTypeContext";
import { Button, Grid } from "@material-ui/core";
import DeleteIcon from "@material-ui/icons/Delete";
import EditIcon from "@material-ui/icons/Edit";
import { ColDef } from "ag-grid-community";
import { find } from "lodash-es";
import { useComponentTypesContext } from "../../../context/ComponentTypeContext";

type Props = {
	setModalEditComponent: Function;
	setModalDeleteComponent: Function;
	setComponentIdForEdit: Function;
	setComponentIdForDelete: Function;
	setModalPart: Function;
};
export const useTableData = ({
	setComponentIdForEdit,
	setModalEditComponent,
	setComponentIdForDelete,
	setModalDeleteComponent,
	setModalPart,
}: Props) => {
	const {
		state: { componentTypes },
	} = useComponentTypesContext();
	const {
		state: { rootTypes },
	} = useRootTypeContext();

	const columns: ColDef[] = [
		{
			field: "componentTypeId",
			headerName: "#",
			width: 70,
		},
		{
			field: "componentTypeName",
			headerName: "Name",
			flex: 1,
		},
		{
			field: "rootTypeId",
			headerName: "Root Type",
			flex: 1,
			filter: "agSetColumnFilter",
		},
		{
			field: "isRepair",
			headerName: "Is Repair",
			flex: 1,
		},
		{
			field: "isTracked",
			headerName: "Is Tracked",
			flex: 1,
		},
		{
			field: "parts",
			headerName: "Parts",
			flex: 1,
			cellRenderer: (params: any) => {
				return (
					<Grid container spacing={1} style={{ padding: "0" }}>
						<Grid item md={6} xs={6} style={{ padding: "0" }}>
							{params.data.isRepair !== "Yes" && (
								<Button
									variant="outlined"
									color="primary"
									size="small"
									onClick={() => {
										(async () => {
											setComponentIdForEdit(params.data.componentTypeId);
											setModalPart(true);
										})();
									}}
								>
									Parts
								</Button>
							)}
						</Grid>
					</Grid>
				);
			},
		},
		{
			field: "Actions",
			cellRenderer: (params: any) => {
				return (
					<Grid
						container
						justifyContent="center"
						alignItems="center"
						spacing={1}
						style={{ padding: "0" }}
					>
						<Grid item md={6} xs={6} style={{ padding: "0", marginLeft: -25 }}>
							<Button
								fullWidth
								onClick={() => {
									(async () => {
										setComponentIdForEdit(params.data.componentTypeId);
										setModalEditComponent(true);
									})();
								}}
							>
								<EditIcon style={{ width: 16, height: 16 }} color="primary" />
							</Button>
						</Grid>
						<Grid item md={6} xs={6} style={{ padding: "0" }}>
							<Button
								fullWidth
								onClick={() => {
									(async () => {
										setComponentIdForDelete(params.data.componentTypeId);
										setModalDeleteComponent(true);
									})();
								}}
							>
								<DeleteIcon
									style={{ width: 16, height: 16 }}
									color="secondary"
								/>
							</Button>
						</Grid>
					</Grid>
				);
			},
			headerName: " ",
			sortable: false,
		},
	];

	const rows = componentTypes.map(
		({
			componentTypeId,
			componentTypeName,
			rootTypeId,
			isRepair,
			isTracked,
		}) => {
			const rootType = find(rootTypes, ["rootTypeId", rootTypeId]);

			return {
				componentTypeId,
				componentTypeName,
				rootTypeId: rootType?.rootTypeName,
				isRepair: isRepair ? "Yes" : "No",
				isTracked: isTracked ? "Yes" : "No",
				id: componentTypeId,
			};
		},
	);

	return { rows, columns };
};
